"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function RequestEstimate() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.15,
    once: true
  });
  return <section id="requestestimatecta" data-nav="light" ref={ref} className="relative py-20 lg:py-28 bg-background text-foreground overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-700 ease-out" style={{
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? "translateY(0)" : "translateY(16px)"
    }}>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          <div className="lg:col-span-5 flex flex-col justify-center space-y-6">
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-foreground leading-tight">
              Ready to plan your Brookhaven renovation?
            </h2>
            <p className="text-base sm:text-lg text-muted-foreground leading-relaxed">
              Schedule a consultation with our team to discuss your architectural vision, 
              project timelines, and preliminary budgeting for your custom kitchen, bath, or whole-home project.
            </p>
            <div className="pt-2">
              <Button size="lg" asChild className="rounded-md">
                <Link to="/ContactRequestAnEstimatePage">
                  Request an Estimate
                  <ArrowRight className="size-4" />
                </Link>
              </Button>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-12 gap-4 lg:gap-6 items-center">
              <div className="sm:col-span-7 overflow-hidden rounded-lg border border-border shadow-md bg-card">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/brookhaven_kitchen_island_remodel.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/brookhaven_kitchen_island_remodel.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/brookhaven_kitchen_island_remodel.webp-wvc-sizes" alt="Bright open-concept kitchen renovation featuring custom quartz island and bespoke wood cabinetry" loading="lazy" decoding="async" className="w-full h-72 sm:h-96 object-cover transition-transform duration-500 hover:scale-105" />
              </div>

              <div className="sm:col-span-5 overflow-hidden rounded-lg border border-border shadow-md bg-card sm:mt-10">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/brookhaven_luxury_master_bath.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/brookhaven_luxury_master_bath.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1821096/img/brookhaven_luxury_master_bath.png-wvc-sizes" alt="Luxury master bathroom remodel with frameless glass walk-in shower and freestanding soaking tub" loading="lazy" decoding="async" className="w-full h-64 sm:h-80 object-cover transition-transform duration-500 hover:scale-105" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}